/* unplugin-vue-components disabled */import script from "./model.vue?vue&type=script&setup=true&name=Model&lang=js"
export * from "./model.vue?vue&type=script&setup=true&name=Model&lang=js"

import "./model.vue?vue&type=style&index=0&id=033a2a17&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-033a2a17"]])

export default __exports__